module.exports = __webpack_public_path__ + "img/vip.1034153a.png";